<div id="popup-confirm-bill" class="popup-overlay modal-default confirm-bill">
  <div class="popup-warp">
      <div class="popup-inner pad-popup">
          <div class="name-popup">Thông tin hoá đơn</div>
          <span class="close-popup" (click)="onCancel()"></span>
          <div class="content-popup">
              <p class="title-name">Hoá đơn</p> 
              <table class="table" width="100%">
                  <thead>
                    <tr>
                      <th scope="col" colspan="2">TÊN SẢN PHẨM</th>
                      <th *ngIf="roofPurcharseConfig.quantityVisible"  scope="col">SỐ<br/>LƯỢNG</th>
                      <th *ngIf="roofPurcharseConfig.amountVisible"  scope="col">THÀNH TIỀN</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let item of listPurcharse; let i = index" >
                          <td>{{i + 1}}</td>
                          <td>{{item.productName}}</td>
                          <td *ngIf="roofPurcharseConfig.quantityVisible">{{item.quantity | number}}</td>
                          <td *ngIf="roofPurcharseConfig.amountVisible"><span [innerHTML]="item.totalAmount | number"></span>đ</td>
                      </tr>
                  </tbody>
              </table>
              <p class="title-name">Banker trong giỏ hàng</p>
              <table class="table" width="100%">
                  <thead>
                    <tr>
                      <th scope="col" colspan="2">TÊN SẢN PHẨM</th>
                      <th *ngIf="roofPurcharseConfig.bankerQuantityVisible" scope="col">SỐ<br/>LƯỢNG</th>
                      <th *ngIf="roofPurcharseConfig.bankerAmountVisible" scope="col">THÀNH TIỀN</th>
                    </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let item of listBanker; let i = index" >
                          <td>{{i + 1}}</td>
                          <td>{{item.productName}}</td>
                          <td *ngIf="roofPurcharseConfig.bankerQuantityVisible">{{item.quantity | number}}</td>
                          <td *ngIf="roofPurcharseConfig.bankerAmountVisible" ><span [innerHTML]="item.totalAmount | number"></span>đ</td>
                      </tr>
                  </tbody>
              </table>
              <p class="title-name">Ghi chú</p>
              <div class="block-feature">
                  <textarea
                    [(ngModel)]="note"
                    id="text-note"
                    rows="3"
                    maxlength="500"
                    placeholder="Nhập ghi chú"
                  ></textarea>
              </div>
              
          </div>
          <div class="group-btn-inline">
              <button class="btn btn-primary btn-border" type="button" (click)="onCancel()">Huỷ</button>
              <button class="btn btn-primary" type="button" (click)="onConfirm()">Xác nhận</button>
          </div>
      </div>
      
  </div>
</div>